<div class="container">
    <sew-ws-button>
        <button oscOcmCreateEntry [templateName]="'SEW_EURODRIVE.market_regulation'" [entryType]="'DATASET'">
            Add new regulation
        </button>
    </sew-ws-button>
    <sew-ws-button>
        <button oscOcmCreateEntry [templateName]="'SEW_EURODRIVE.market_product'" [entryType]="'DATASET'">
            Add new product
        </button>
    </sew-ws-button>
</div>
<div class="container">
    <sew-combobox
        ws
        comboboxId="country"
        (itemSelected)="changeCountry($any($event).detail.value)"
        [placeholder]="'Select Country'"
        [hideNoSelectionOption]="true"
    >
        <select title="Select Country">
            <option></option>
            @for (country of allAvailableCmsCountries; track country) {
                <option [value]="country.countryCode">
                    {{ country.name }}
                </option>
            }
        </select>
    </sew-combobox>

    <sew-combobox
        ws
        comboboxId="language-select"
        (itemSelected)="selectedLangauge = $any($event).detail.value"
        [placeholder]="'Select Language'"
        [hideNoSelectionOption]="true"
    >
        <select title="Select Country">
            <option></option>
            @for (language of allAvailableLanguages; track language) {
                <option
                    [value]="language.code"
                    [attr.selected]="language.code === selectedLangauge ? true : null"
                >
                    {{ language.name }}
                </option>
            }
        </select>
    </sew-combobox>

    <sew-ws-button>
        <button (click)="changeLocalization()">Switch</button>
    </sew-ws-button>
</div>
